import React from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CustomButton from "../../../CustomButton";
import { formatVehicleName, formatGroup, formatTimestamp, formatFileSize } from '../../../helpers/tablesFuncHelpers';
import '../../../common/MobileGridCards.sass';

const AssetActivityMobileCard = ({ row, editVehicle }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });

	const nameLabel = formatVehicleName(row.device_id, row);

	const baseData = [
		{ label: t('Group'), value: formatGroup(row.groups, row) },
		{ label: t('Last_Connected'), value: formatTimestamp(row.last_connected) },
		{ label: t('Last_Event'), value: formatTimestamp(row.last_event) },
	];

	const additionalData = [
		{ label: t('Last_Uploaded_Event'), value: formatTimestamp(row.last_uploaded_event) },
		{ label: t('Event_Count'), value: row.count },
		{ label: t('Total_File_Size'), value: formatFileSize(row.total_size) },
	];

	return (
		<Card className="mobile-grid-card mobile-accordion-card">
			<Card.Body>
				<div className="mobile-card-header">
					<div className="mobile-card-info">
						<CustomButton variant="link" onClick={(e) => editVehicle(e, row.device_id)}>{nameLabel}</CustomButton>
						{baseData.map(({ label, value }) => (
							<div className="mobile-card-info-row" key={label}>
								<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
							</div>
						))}
					</div>
				</div>
				<Accordion>
					<Accordion.Item eventKey="0">
						<Accordion.Header className="mobile-card-toggle" />
						<Accordion.Body>
							<div className="mobile-card-data">
								{additionalData.map(({ label, value }) => (
									<div className="mobile-card-data-item" key={label}>
										<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
									</div>
								))}
							</div>
						</Accordion.Body>
					</Accordion.Item>
				</Accordion>
			</Card.Body>
		</Card>
	);
};

export default AssetActivityMobileCard;
